import React, { forwardRef } from 'react'
import { CustomModal } from '@components'
import { Box, Typography } from '@mui/material'
import { useDeleteChatMessagesMutation } from '@store/feature/chat/chatApi'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { GAS_PATH, ELECTRICITY_PATH, showToast } from '@utils';

const DeleteModal = forwardRef(({ handleClose }, ref) => {
    const { id } = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const [deleteChatMessages] = useDeleteChatMessagesMutation()

    const handleSubmit = async (e) => {
        e.preventDefault()
        const resp = await deleteChatMessages(id)
        if (resp?.error?.originalStatus) {
            showToast('error', 'Something went wrong')
            return
        }
        navigate(`${location.pathname.includes("gas") ? GAS_PATH.CHAT : ELECTRICITY_PATH.CHAT}`)
        handleClose()
    }

    return (
        <CustomModal
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            modalTitle={`Delete Chat`}
            buttonText={'Delete Chat'}
            modalTitleColor={'#EB6969'}
            className='modal-button-danger'
            ref={ref}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                    color: 'black',
                }}
            >
                <Box>
                    <Typography
                        sx={{
                            fontSize: '14px'
                        }}
                    >
                        Are you sure you want to delete this chat?
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '14px'
                        }}
                    >
                        By deleting the chat you are deleting all the messages and media shared in this chat
                    </Typography>
                </Box>
                <Typography
                    sx={{
                        fontSize: '14px'
                    }}
                >
                    Please note that by deleting the chat, other person can still see all the messages
                </Typography>
            </Box>
        </CustomModal>
    )
})

export default DeleteModal